<script setup lang="ts">
import { computed } from 'vue'
import { useUiStore } from '@/stores/ui'
import AdminSidebar from '@/components/layout/AdminSidebar.vue'
import AdminHeader from '@/components/layout/AdminHeader.vue'
import AppToast from '@/components/ui/AppToast.vue'
import SessionTimeoutWarning from '@/components/ui/SessionTimeoutWarning.vue'

const uiStore = useUiStore()
const isCollapsed = computed(() => uiStore.sidebarCollapsed)
</script>

<template>
  <div class="min-h-screen bg-bg-secondary flex flex-col">
    <!-- Sticky header — full width, always on top -->
    <AdminHeader class="sticky top-0 z-sticky" />

    <!-- Below header: sidebar + content -->
    <div class="flex flex-1 min-h-0">
      <!-- Sidebar — sticky below header, own scroll -->
      <AdminSidebar />

      <!-- Main content area -->
      <main
        :class="[
          'flex-1 p-6 transition-all duration-base min-w-0',
          isCollapsed ? 'ml-[70px]' : 'ml-[240px]',
        ]"
        data-testid="admin-layout-content"
      >
        <RouterView />
      </main>
    </div>

    <!-- Global overlays -->
    <AppToast />
    <SessionTimeoutWarning />
  </div>
</template>
